import 'core-js/stable'
import 'regenerator-runtime/runtime'

// Polyfills that are currently not configured via babel
import 'whatwg-fetch'
import 'document-register-element/build/document-register-element'
import 'intl'

import 'mutationobserver-shim'
import '@/helper/installCompositionApi.js'
import Vue from 'vue'
import '@/plugins/bootstrap-vue'
import '@/mixins/import'
import { register as registerCustomElements } from '@/helper/customElementsHelper'
import * as Store from '@/store'
import vueCustomElement from 'vue-custom-element'
import { createProvider, getProvider, onLogout } from '@/apollo'
import axios from 'axios'

import MessageView from '@/components/generic/MessageView/MessageList'
import DynSlot from '@/components/generic/DynSlot'
import Tooltip from '@/components/generic/Tooltip'

import Config from '../config'
import { globalStoreConfig, PERSISTENCE_KEY } from '@/store/config'
import { storeConfig } from '@/store/config/flash'

import CustomerProfile from '@/components/process/generic/PersonalData/CustomerProfile.vue'
import LogOutLink from './components/process/generic/LogOutLink'
import TeaserText from '@/components/generic/TeaserText'
import Notification from '@/components/process/generic/Login/Notifications/Notification'
import SimShoppingCartWrapper from '@/components/process/wrapper/SelfService/SimCard/SimShoppingCartWrapper'
import EmailConfirmationWrapper from '@/components/process/wrapper/EmailConfirmationWrapper.vue'
import TariffTileHorizontalWrapper from '@/components/checkout/tarifftile/TariffTileHorizontalWrapper.vue'
import ActivationTariffTileHorizontalWrapper from '@/components/checkout/tarifftile/ActivationTariffTileHorizontalWrapper.vue'
import LandingPageLoadPromotionWrapper from '@/components/process/wrapper/LandingPage/LoadPromotionWrapper'
import ForgotPasswordWrapper from '@/components/process/wrapper/ForgotPasswordWrapper.vue'
import Vue2MigrationHelper from '@/components/generic/Vue2MigrationHelper'
import ResetPasswordConfirmationWrapper from '@/components/process/wrapper/ResetPasswordConfirmationWrapper.vue'
import ShowResetPasswordSuccess from '@/components/process/generic/ResetPasswordConfirmation/ShowResetPasswordSuccess.vue'
import FeedbackWrapper from '@/components/process/wrapper/FeedbackWrapper.vue'
import CurrentTariff from '@/components/process/generic/Tariff/CurrentTariff.vue'
import TariffDetails from '@/components/process/generic/Tariff/TariffDetails.vue'
import KWKTariffTileWrapper from '@/components/checkout/tarifftile/KWKTariffTileWrapper.vue'
import SelfServiceContractBillsWrapper from '@/components/process/wrapper/SelfService/Contract/BillsWrapper'
import SelfServiceContractMnpOutWrapper from '@/components/process/wrapper/SelfService/Contract/MnpOutWrapper'
import SelfServiceContractDismissalModal from '@/components/process/wrapper/SelfService/Contract/DismissalModal'
import SelfServiceContractDismissalForm from '@/components/process/wrapper/SelfService/Contract/DismissalForm'
import DashboardWrapper from '@/components/process/wrapper/SelfService/DashboardWrapper.vue'
import KWKDashboardWrapper from '@/components/process/wrapper/SelfService/KWKDashboardWrapper.vue'
import SelfServiceProfileConsentWrapper from '@/components/process/wrapper/ConsentWrapper.vue'
import ExtraOptions from '@/components/process/generic/ExtraOptions/ExtraOptionsWrapper.vue'
import CancelledTariffBanner from '@/components/process/generic/Tariff/CancelledTariffBanner.vue'
import ContractSummaryWrapper from '@/components/process/wrapper/LandingPage/ContractSummaryWrapper'
import CheckSIMCard from './components/process/generic/CheckSIMCard/View.vue'
import TerminationForm from '@/components/process/generic/Termination/TerminationForm'
import TerminationSuccess from '@/components/process/generic/Termination/TerminationSuccess'
import ESimPush from './components/process/generic/ESimPush/ESimPush'
import ESimPushWithToken from './components/process/generic/ESimPush/ESimPushWithToken'
import ActivationStartWrapper from '@/components/checkout/activation/PreActivation/ActivationStartWrapper.vue'
import CustomerProfileWithChange from '@/components/process/generic/PersonalData/CustomerProfileWithChange.vue'
import TariffOptionsOverviewWrapper from '@/components/process/wrapper/TariffOptionsDashboardWrapper.vue'
import TariffBreak from '@/components/process/generic/ChangeTariff/TariffBreak.vue'
import FeatureFlag from '@/components/demo/FeatureFlag'
import ContactForm from '@/components/process/wrapper/ContactForm.vue'
import VolumesAboOption from '@/components/checkout/tarifftile/generic/VolumesAboOption.vue'
import StartingBonus from '@/components/generic/Promotions/StartingBonus'
import SimCardWrapper from '@/components/process/wrapper/SelfService/SimCard/SimCardWrapper'
import TextBadge from '@/components/generic/Promotions/TextBadge'
import TextBadgeWithInfoIcon from '@/components/generic/Promotions/TextBadgeWithInfoIcon'
import BannerWithCountdown from '@/components/generic/Promotions/BannerWithCountdown'
import OrderSubstituteESimWrapper from '@/components/process/generic/SubstituteSimCard/OrderSubstituteESimWrapper.vue'
import SubstituteSimSuccess from '@/components/process/generic/SubstituteSimCard/SubstituteSimSuccess.vue'
import NotificationListWrapper from '@/components/process/wrapper/SelfService/NotificationList/NotificationListWrapper'
import ContractSummaryError from '@/components/generic/ContractSummary/ContractSummaryFailure'
import LinkTerms from '@/components/generic/LinkTerms.vue'
import ShowValidationError from '@/components/process/generic/Kwk/ShowValidationError'
import SearchSelect from '@/components/process/generic/Search/SearchSelect.vue'
import SearchResults from '@/components/process/generic/Search/SearchResults.vue'
import PushCart from '@/components/process/generic/ESimPush/PushCart.vue'
import ContentSimonModal from './components/modal/ContentSimonModal.vue'
import Ordering from '@/components/checkout/ordering/Ordering.vue'
import Activation from '@/components/checkout/activation/Activation.vue'
import CheckoutSuccess from '@/components/checkout/success/Success.vue'
import CheckoutSuccessIdent from '@/components/checkout/success/SuccessWithIdent.vue'
import PreActivationSteps from '@/components/checkout/activation/PreActivation/PreActivationSteps.vue'
import URLParamModal from '@/components/modal/URLParamModal.vue'
import ABTestingContent from '@/components/abTesting/ABTestingContent.vue'
import BelatedPorting from '@/components/checkout/belatedPorting/BelatedPorting.vue'
import BelatedPortingSuccess from '@/components/checkout/belatedPorting/Success.vue'
import SubstituteSim from '@/components/checkout/substituteSim/SubstituteSim.vue'

const API_BASE_URL = process.env.VUE_APP_FLASH_API_BASE_URL || process.env.VUE_APP_API_BASE_URL
const GRAPHQL_HTTP = process.env.VUE_APP_FLASH_GRAPHQL_HTTP || process.env.VUE_APP_GRAPHQL_HTTP

const TRIGGER_SESSION_TRANSFER = 'getSessionStorage'
const TRANSFER_KEY = 'sessionStorage'

Vue.use(Config, {
  apiUrl: API_BASE_URL,
  errorPage408: '/error_408',
  errorPage503: '/error_503'
})

let store

// transfers sessionStorage from one tab to another

function sessionStorageTransfer (event) {
  if (!event) {
    event = window.event
  } // ie suq
  if (!event.newValue) return
  // do nothing if no value to work with
  if (event.key === TRIGGER_SESSION_TRANSFER) {
    // another tab asked for the sessionStorage -> send it
    localStorage.setItem(TRANSFER_KEY, JSON.stringify(sessionStorage.getItem('portal-session')))
    // the other tab should now have it, so we're done with it.
    localStorage.removeItem(TRANSFER_KEY) // <- could do short timeout as well.
  } else if (event.key === TRANSFER_KEY) {
    // another tab sent data <- get it
    if (sessionStorage.getItem('portal-session') != null) {
      // other tab was quicker. ignore this one
      return
    }
    const data = JSON.parse(event.newValue)
    sessionStorage.setItem('portal-session', data)
    store = Store.createStore({
      ...globalStoreConfig,
      ...storeConfig
    })
    initializeApplication()
  }
}

// listen for changes to localStorage
if (window.addEventListener) {
  window.addEventListener('storage', sessionStorageTransfer, false)
} else {
  window.attachEvent('onstorage', sessionStorageTransfer)
}
// The opened tab requests the session storage content
// this is performed async
// wann wollen wir abrufen?
//   neuer Tab!
//   1. aktuell keine portal-session
//   2. (window.history = 1)
if (sessionStorage.getItem('portal-session') == null) {
  localStorage.setItem(TRIGGER_SESSION_TRANSFER, 'foobar')
  localStorage.removeItem(TRIGGER_SESSION_TRANSFER, 'foobar')
  // if there is no other tab open, nobody will answer :(
  // so we have to set a timeout to do the stuff ourself :)
  setTimeout(function () {
    if (sessionStorage.getItem('portal-session') == null) {
      initializeStore()
      initializeApplication()
    }
  }, 100)
} else {
  initializeStore()
  initializeApplication()
}

// End transfers sessionStorage from one tab to another

function initializeStore () {
  const defaultRetailerId = 30861174

  store = Store.createStore({
    ...globalStoreConfig,
    ...storeConfig
  })
  store.commit('selectBrand', 'simon')
  store.commit('selectRetailerId', getEffectiveRetailerId(defaultRetailerId))
  store.commit('selectType', 'DELIVERY')
  // ggf. hier auf ENVs gehen, wenn nötig -> process.env.LIDL_CLIENT_ID + LIDL_CLIENT_SECRET
  store.commit('selectClient', {
    id: 'simon',
    secret: 'simon'
  })
  store.commit('selectBaseUrl', API_BASE_URL)

  setFeatureFlags(store)
  setPromoConfig(store)
  store.dispatch('abTesting/importCampaignsFromContao')
}

function setFeatureFlags (store) {
  store.dispatch('feature/importFeaturesFromCto')
  // share features state with outside world
  window.setFeature = (payload) => store.commit('feature/setFeature', payload)
}

function setPromoConfig (store) {
  const data = require('@/config/promotion/flash/positions.yml')
  store.dispatch('promotion/initializePositionConfig', data)
  store.dispatch('promotion/importConfigFromCto')
  store.dispatch('promotion/promoCode/importVoucherConfigFromCto')
}

function getEffectiveRetailerId (defaultRetailerId) {
  let retailerId = defaultRetailerId
  if (window.cookieNS && window.cookieNS.main) {
    // try to update the cookie value jit
    if (window.cookieNS.main.updateRetailerIdCookie) {
      window.cookieNS.main.updateRetailerIdCookie()
    }

    if (window.cookieNS.main.getCookie) {
      const cookieRetailerId = window.cookieNS.main.getCookie('SIMonVOID')
      if (cookieRetailerId) {
        retailerId = cookieRetailerId
      }
    }
  }

  // ensure it's set even if cookie is set (but empty)
  if (!retailerId) {
    retailerId = defaultRetailerId
  }

  return retailerId
}

function initializeApplication () {
  const apolloProvider = createProvider(store, {
    autoLogoutMessage: 'Es ist ein technischer Fehler aufgetreten. Sie wurden zur Sicherheit abgemeldet. Bitte melden Sie sich erneut an. Sollten die Probleme bestehen bleiben, so wenden Sie sich an die Hotline.',
    httpEndpoint: GRAPHQL_HTTP,
    restEndpoint: API_BASE_URL,
    errorRedirects: {
      408: '/error_408',
      503: '/error_503'
    }
  })
  Vue.component('dyn-slot', DynSlot)
  Vue.config.productionTip = false
  Vue.config.ignoredElements = [/^sapp-/]
  Vue.use(vueCustomElement)
  Vue.component('dyn-slot', DynSlot)
  registerCustomElements({
    // generics
    'app-tooltip': Tooltip,
    'app-teaser-text': TeaserText,
    'app-vue2-migration-helper': Vue2MigrationHelper,
    'app-check-sim-card': CheckSIMCard,
    // demo
    'demo-feature-flag': FeatureFlag,
    // processes
    'app-message-view': MessageView,
    'app-notification': Notification,
    'app-contract-summary': ContractSummaryWrapper,
    'app-customer-profile': CustomerProfile,
    'app-customer-profile-with-change': CustomerProfileWithChange,
    'app-logout': LogOutLink,
    'app-sim-shopping-cart': SimShoppingCartWrapper,
    'app-email-confirmation-wrapper': EmailConfirmationWrapper,
    'app-forgot-password-wrapper': ForgotPasswordWrapper,
    'app-landingpage-load-promotion': LandingPageLoadPromotionWrapper,
    'app-reset-password-confirmation-wrapper': ResetPasswordConfirmationWrapper,
    'app-show-reset-password-success': ShowResetPasswordSuccess,
    'app-feedback-wrapper': FeedbackWrapper,
    'app-current-tariff': CurrentTariff,
    'app-tariff-details': TariffDetails,
    'app-kwk-tariff-tile': KWKTariffTileWrapper,
    'app-landingpage-tariff-tile-horizontal': TariffTileHorizontalWrapper,
    'app-activation-tariff-tile-horizontal': ActivationTariffTileHorizontalWrapper,
    'app-customer-contract-bills': SelfServiceContractBillsWrapper,
    'app-customer-contract-mnpout': SelfServiceContractMnpOutWrapper,
    'app-customer-contract-dismissal-modal': SelfServiceContractDismissalModal,
    'app-customer-contract-dismissal-form': SelfServiceContractDismissalForm,
    'app-selfservice-dashboard-wrapper': DashboardWrapper,
    'app-selfservice-kwk-dashboard-wrapper': KWKDashboardWrapper,
    'app-customer-profile-consents': SelfServiceProfileConsentWrapper,
    'app-start-activation': ActivationStartWrapper,
    'app-pre-activation': PreActivationSteps,
    'app-extra-options': ExtraOptions,
    'app-cancelled-tariff-banner': CancelledTariffBanner,
    'app-tariff-options-overview-wrapper': TariffOptionsOverviewWrapper,
    'app-tariff-break': TariffBreak,
    'app-contact-form': ContactForm,
    'app-sim-card-wrapper': SimCardWrapper,
    'app-promo-text-badge': TextBadge,
    'app-promo-text-badge-with-info-icon': TextBadgeWithInfoIcon,
    'app-volumes-abo-option': VolumesAboOption,
    'app-promo-starting-bonus': StartingBonus,
    'app-banner-with-countdown': BannerWithCountdown,
    'app-order-substitute-esim-wrapper': OrderSubstituteESimWrapper,
    'app-substitute-sim-success': SubstituteSimSuccess,
    'app-substitute-sim': SubstituteSim,
    'app-notification-list-wrapper': NotificationListWrapper,
    'app-contract-summary-failure': ContractSummaryError,
    'app-link-terms': LinkTerms,
    'app-termination-form': TerminationForm,
    'app-termination-success': TerminationSuccess,
    'app-kwk-show-validation-error': ShowValidationError,
    'app-esim-push': ESimPush,
    'app-esim-push-with-token': ESimPushWithToken,
    'app-esim-push-cart': PushCart,
    'app-search-select': SearchSelect,
    'app-search-results': SearchResults,
    'app-content-simon-modal': ContentSimonModal,
    'app-url-param-modal': URLParamModal,
    'app-ordering': Ordering,
    'app-belated-porting': BelatedPorting,
    'app-belatedporting-success': BelatedPortingSuccess,
    'app-activation': Activation,
    'app-checkout-success': CheckoutSuccess,
    'app-checkout-success-ident': CheckoutSuccessIdent,
    'app-ab-testing-content': ABTestingContent
  }, store, apolloProvider)
}

const GENERIC_NETWORK_ERROR_MESSAGE = 'Ufff! Leider ist die Verbindung gerade abgebrochen (Fehler: L1). Bitte probier\'s gleich noch einmal.  '

axios.interceptors.response.use(undefined, (error) => {
  if (error.message === 'Network Error') error.message = GENERIC_NETWORK_ERROR_MESSAGE
  return Promise.reject(error)
})

let loggingOut = false

window.onload = function () {
  // watch child mutations on the html body
  const body = document.getElementsByTagName('body')[0]
  const mutationObserver = new MutationObserver((mutationList) => {
    mutationList.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // call only on add of childs
        // if performance is to low, we can use the mutation.parentElement as selector istead of full body here
        window.bindDownloadLinks(body)
      }
    })
  })
  mutationObserver.observe(body, {
    attributes: false,
    childList: true,
    subtree: true
  })

  // initial
  window.bindDownloadLinks(body)
}

window.bindDownloadLinks = function (element) {
  const downloadElementClassName = 'download-handler'
  var downloadLinks = element.getElementsByClassName(downloadElementClassName)
  Array.from(downloadLinks).forEach((downloadLink) => {
    downloadLink.addEventListener('click', (event) => {
      event.preventDefault()
      const realUrl = downloadLink.getAttribute('data-href')
      if (realUrl) {
        const target = downloadLink.getAttribute('target')
        if (target) {
          window.open(realUrl, target).focus()
        } else {
          window.location.href = realUrl
        }
      }
      return false
    })
    // remove class when bind is done, we don' t need it for styling
    downloadLink.classList.remove(downloadElementClassName)
  })
}

window.logoutClearAuth = function (callContaoLogout = true) {
  if (!loggingOut) {
    store.dispatch('removeAuthTokens')
    store.commit('clearMessages', { root: true })
    if (callContaoLogout) {
      store.dispatch('logout').then(function () {
        sessionStorage.removeItem(PERSISTENCE_KEY)
        const apolloClient = getProvider().defaultClient
        if (apolloClient) {
          onLogout(apolloClient)
        }
      })
      fetch('/_contao/logout', {
        method: 'GET',
        redirect: 'manual'
      }).then(response => {
        if (window.App !== undefined && window.App.reset !== undefined && window.App.refreshedToken !== undefined) {
          if (window.isIosDevice) {
            window.webkit.messageHandlers.reset.postMessage('getting new access token failed')
          } else {
            window.App.reset('getting new access token failed')
          }
        } else {
          window.location.href = '/'
        }
      })
    }
    loggingOut = true
  }
}
